import DereferenceError from "./DereferenceError.mjs";
class MaximumDereferenceDepthError extends DereferenceError {}
export default MaximumDereferenceDepthError;